export type { UploadAreaProps } from './UploladArea.types'
export { default as UploadArea } from './UploadArea'